import React from "react";

import { AdyenPaiementsOverview } from "./reporting/AdyenPaiementsOverview";
import { AdyenTransactionsOverview } from "./reporting/AdyenTransactionsOverview";
import { useQueryString } from "../hooks/useQueryString";
import { AdyenReportsOverview } from "./reporting/AdyenReportsOverview";

export function HomePage() {
  const { accountHolder, role } = useQueryString();

  if (accountHolder !== undefined) {
    localStorage.setItem("accountHolderId", accountHolder);
    localStorage.setItem("role", role);
  }

  const renderComponent = () => {
    switch (role) {
      case "paiements":
        return <AdyenPaiementsOverview />;
      case "transactions":
        return <AdyenTransactionsOverview />;
      case "reports":
        return <AdyenReportsOverview />;
      default:
        return null;
    }
  };

  return <React.Fragment>{renderComponent()}</React.Fragment>;
}
